import React from "react";
import { Edit, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ScheduledLetterActionsProps {
  letterId: string;
  userPlan: string | null;
  isAdmin: boolean;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export function ScheduledLetterActions({ 
  letterId, 
  userPlan,
  isAdmin,
  onEdit, 
  onDelete 
}: ScheduledLetterActionsProps) {
  const canEdit = userPlan === 'premium' || isAdmin;

  return (
    <div className="flex justify-end gap-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onEdit(letterId)}
        className="h-8 w-8 hover:bg-blue-50 hover:text-blue-600"
        title={canEdit ? "Editar carta" : "Edição disponível apenas para o plano Premium"}
        disabled={!canEdit}
      >
        <Edit className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onDelete(letterId)}
        className="h-8 w-8 text-red-500 hover:text-red-700 hover:bg-red-50"
        title="Excluir carta"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}